import { render, staticRenderFns } from "./InvoicePOS.vue?vue&type=template&id=56010c6e&scoped=true"
import script from "./InvoicePOS.vue?vue&type=script&lang=js"
export * from "./InvoicePOS.vue?vue&type=script&lang=js"
import style0 from "./InvoicePOS.vue?vue&type=style&index=0&id=56010c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56010c6e",
  null
  
)

export default component.exports